import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import dayjs from 'dayjs'
import {DownloadIcon} from "../../../../../icons";

export const toolbarActions = ({
  totalCount,
  exportFileExcel,
  isExcelExportLoading
}) => {
  let actions = []

  if (totalCount>0 && totalCount<=1000) {
    actions = [
      ...actions,
      {
        label: isExcelExportLoading ? 'Export in curs...' : 'Export Excel',
        icon: <DownloadIcon />,
        onClick: isExcelExportLoading ? () => {} : exportFileExcel
      }
    ]
  }

  return actions
}

export const columns = () => [
  {
    title: 'Număr comandă',
    field: 'orderNumber',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Magazin',
    field: 'shopCode',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Furnizor Direct',
    field: 'supplierName',
    align: 'left',
    type: 'string',
    render: row => `${row.supplierName} (${row?.supplierCode})`,
    width: '100px'
  },
  {
    title: 'Cod Articol',
    field: 'articleCode',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Nume Produs',
    field: 'articleName',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Unitate de măsură',
    field: 'measureUnit',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Cantitate asteptata',
    field: 'orderedQuantity',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Cantitate receptionata',
    field: 'receivedQuantity',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Diferență',
    field: 'missingQuantity',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Nr. linie comanda',
    field: 'orderLineNumber',
    align: 'left',
    type: 'string',
    width: '100px'
  }
]

export const drawerFilters = (shopCodes?: Array<{ label: string; value: string }>, orderNumberFromNav?) => [
  {
    name: 'orderNumber',
    value: orderNumberFromNav ?? '',
    filter: <Input variant="outlined" label="Nr. comandă" type="text" />,
    type: 'text',
    label: 'Nr. comandă'
  },
  {
    name: 'shopCode',
    value: null,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează magazin"
        disableClearable
        options={shopCodes || []}
      />
    ),
    type: 'autocomplete',
    label: 'Selectează magazin'
  },
  {
    name: 'supplierCode',
    value: '',
    filter: <Input variant="outlined" label="Cod furnizor" type="number" />,
    type: 'number',
    label: 'Cod furnizor'
  },
  {
    name: 'supplierName',
    value: '',
    filter: <Input variant="outlined" label="Furnizor" type="text" />,
    type: 'text',
    label: 'Furnizor direct'
  },
  {
    name: 'articleCode',
    value: '',
    filter: <Input variant="outlined" label="Cod articol" type="text" />,
    type: 'text',
    label: 'Cod articol'
  },
  {
    name: 'measureUnit',
    value: '',
    filter: <Input variant="outlined" label="UM" type="text" />,
    type: 'text',
    label: 'UM'
  },
  {
    name: 'orderedQuantity',
    value: '',
    filter: <Input variant="outlined" label="Cant. asteptata" type="text" />,
    type: 'text',
    label: 'Cant. asteptata'
  },
  {
    name: 'receivedQuantity',
    value: '',
    filter: <Input variant="outlined" label="Cant. receptionata" type="text" />,
    type: 'text',
    label: 'Cant. receptionata'
  },
  {
    name: 'missingQuantity',
    value: '',
    filter: <Input variant="outlined" label="Diferență" type="text" />,
    type: 'text',
    label: 'Diferență'
  },
  {
    name: 'orderLineNumber',
    value: '',
    filter: <Input variant="outlined" label="Nr. linie comanda" type="number" />,
    type: 'number',
    label: 'Nr. linie comanda'
  }
]
